import apiClient from './api-client';

const agendamentosService = {
    listar: async (data) => {
        try {
          const response = await apiClient.get('/agendamentos/dia', {
            params: {
              data: data,
            }
          });
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      listarPorProfissionaleData: async (data, profissionalId) => {
        try {
          const response = await apiClient.get('/agendamentos/dia', {
            params: {
              data: data,
              profissionalId: profissionalId
            }
          });
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      listarPorProfissional: async (profissionalId) => {
        try {
          const response = await apiClient.get('/agendamentos/dia', {
            params: {
              profissionalId: profissionalId
            }
          });
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      obter: async (id) => {
        try {
          const response = await apiClient.get('/agendamentos/:id');
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      inserir: async (data) => {
        try {
          const response = await apiClient.post('/agendamentos', data);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      cancelar: async (id, usuarioLogadoId) => {
        try {
          const response = await apiClient.patch(`/agendamentos/${id}/cancelamento`, {usuarioLogadoId});
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      agendarPaciente: async (agendamentoAtual) => {
        try {
          const response = await apiClient.patch(`/agendamentos/${agendamentoAtual.id}/agendar-paciente`, agendamentoAtual);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      confirmarPresenca: async (agendamentoAtual) => {
        try {
          const response = await apiClient.patch(`/agendamentos/${agendamentoAtual.id}/confirmar-presenca`, agendamentoAtual);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
      marcarFalta: async (agendamentoAtual) => {
        try {
          const response = await apiClient.patch(`/agendamentos/${agendamentoAtual.id}/marcar-falta`, agendamentoAtual);
          return response.data;
        } catch (error) {
            console.log("ERROR", error.response.data?.message)
          throw error.response ? error.response.data : new Error('Erro de rede');
        }
      },
    }
  
export default agendamentosService;